// ========================================
// HOOK useMediaLibrary
// Gestion de la bibliothèque de médias
// ========================================

import { useState, useEffect, useCallback } from 'react';
import {
  getAllMedias,
  addMedia,
  addMultipleMedias,
  deleteMedia,
  deleteMultipleMedias
} from '../services/firebase/mediaService';
import { toast } from 'react-toastify';

const useMediaLibrary = (autoFetch = true) => {
  const [medias, setMedias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMedias = useCallback(async () => {
    setLoading(true);
    setError(null);

    const result = await getAllMedias();

    if (result.success) {
      setMedias(result.data);
    } else {
      setError(result.error);
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    if (autoFetch) {
      fetchMedias();
    }
  }, [autoFetch, fetchMedias]);

  const uploadMedia = async (mediaData) => {
    const result = await addMedia(mediaData);

    if (result.success) {
      // Ajouter le nouveau média en haut de la liste
      setMedias(prev => [{
        id: result.id,
        ...mediaData,
        uploadedAt: new Date()
      }, ...prev]);
      return { success: true, id: result.id };
    } else {
      toast.error('Erreur lors de l\'enregistrement du média');
      return { success: false, error: result.error };
    }
  };

  const uploadMultipleMedias = async (mediasData) => {
    const result = await addMultipleMedias(mediasData);

    if (result.success) {
      await fetchMedias(); // Recharger la liste
      return { success: true };
    } else {
      toast.error('Erreur lors de l\'enregistrement des médias');
      return { success: false, error: result.error };
    }
  };

  const removeMedia = async (mediaId) => {
    const result = await deleteMedia(mediaId);

    if (result.success) {
      setMedias(prev => prev.filter(m => m.id !== mediaId));
      toast.success('Média supprimé');
      return { success: true };
    } else {
      toast.error('Erreur lors de la suppression');
      return { success: false, error: result.error };
    }
  };

  const removeMultipleMedias = async (mediaIds) => {
    const result = await deleteMultipleMedias(mediaIds);

    if (result.success) {
      setMedias(prev => prev.filter(m => !mediaIds.includes(m.id)));
      toast.success(`${mediaIds.length} média(s) supprimé(s)`);
      return { success: true };
    } else {
      toast.error('Erreur lors de la suppression');
      return { success: false, error: result.error };
    }
  };

  return {
    medias,
    loading,
    error,
    fetchMedias,
    uploadMedia,
    uploadMultipleMedias,
    removeMedia,
    removeMultipleMedias
  };
};

export default useMediaLibrary;